import { render } from "./MySideBarCompany.vue?vue&type=template&id=0465cda1"
import script from "./MySideBarCompany.vue?vue&type=script&lang=js"
export * from "./MySideBarCompany.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__